import api from '../axios/axiosInstance';

export interface UserActiveModulesSubscriptions {
  _id: string;
  userId: string;
  moduleId: {
    _id: string;
    moduleId: string;
    name: string;
    description: string;
    type: string;
    isActive: boolean;
    version: number;
    dependencies: string[];
    pricing: {
      monthly: number;
      yearly: number;
      currency: string;
      trialDays: number;
    };
    features: string[];
    permissions: string[];
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  status: string;
  billingCycle: 'monthly' | 'yearly';
  startDate: string;
  endDate: string;
  trialDays: number;
  amount: number;
  currency: string;
  autoRenew: boolean;
  createdAt: string;
  updatedAt: string;
}

const getUserActiveModulesSubscriptions = async (): Promise<UserActiveModulesSubscriptions[]> => {
  const response = await api.get('/users/active-modules-subscriptions');
  return response.data;
};

export default getUserActiveModulesSubscriptions;
